/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type { BootstrapRead, ErrorResponse } from "../../model";
import type { ErrorType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns everything a client app needs at startup for the tenant resolved from the request domain: tenant identity (the `tenant_name` slug and the resolved `display_name`), branding, and feature flags. Public -- called before authentication so the app can boot with identity, theme, and gated features in one round trip. `branding` is `null` (not a 404) when the tenant has not configured branding yet.
 * @summary Get app-bootstrap data for the current tenant
 */
export const getBootstrapForCurrentTenantBootstrapGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<BootstrapRead>(
    { url: `/bootstrap`, method: "GET", signal },
    options
  );
};

export const getGetBootstrapForCurrentTenantBootstrapGetQueryKey = () => {
  return [`/bootstrap`] as const;
};

export const getGetBootstrapForCurrentTenantBootstrapGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBootstrapForCurrentTenantBootstrapGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>
  > = ({ signal }) =>
    getBootstrapForCurrentTenantBootstrapGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBootstrapForCurrentTenantBootstrapGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>
>;
export type GetBootstrapForCurrentTenantBootstrapGetQueryError =
  ErrorType<ErrorResponse>;

export function useGetBootstrapForCurrentTenantBootstrapGet<
  TData = Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
          TError,
          Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBootstrapForCurrentTenantBootstrapGet<
  TData = Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
          TError,
          Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBootstrapForCurrentTenantBootstrapGet<
  TData = Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get app-bootstrap data for the current tenant
 */

export function useGetBootstrapForCurrentTenantBootstrapGet<
  TData = Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBootstrapForCurrentTenantBootstrapGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetBootstrapForCurrentTenantBootstrapGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
